<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/clients">Applications</router-link></li>
        <template v-if="update == true">
          <li><router-link v-bind:to="`/clients/${this.$route.params.client_id}`">{{ this.$store.state.client.name }}</router-link></li>
          <li class="is-active"><a href="#" aria-current="page">Edit application name</a></li>
        </template>
        <li v-else class="is-active"><a href="#" aria-current="page">Create a new application</a></li>
      </ul>
    </nav>

    <modal v-bind:visible="showClientCredentialsModal" v-on:close="hideClientCredentialsModal">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="title is-4">Notice</p>
        </header>
        <section class="modal-card-body">
          <div class="media">
            <div class="media-left">
              <span class="icon is-large has-text-warning"><i class="fa fa-3x fa-exclamation-triangle"></i></span>
            </div>
            <div class="media-content">
              <p>Please, copy the <strong>identifier</strong> below and store it in a safe place. This will not be shown again.</p>
              <p><strong>Identifier:</strong> <code>{{ this.$store.state.client.identifier }}</code></p>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" v-on:click="hideClientCredentialsModal">OK</button>
        </footer>
      </div>
    </modal>

    <div class="columns">
      <div class="column is-6 is-offset-3" v-on:keyup.enter="submit">
        <div class="field">
          <label class="label">Application name</label>
          <div class="control">
            <input
              name="name"
              type="text"
              placeholder="Client name"
              v-model="fields.name"
              v-bind:class="{ 'input': true, 'is-danger': veeErrors.has('name') }"
              v-validate="'required'"
              data-vv-as="Client name">
          </div>
          <span v-show="veeErrors.has('name')" class="help is-danger">{{ veeErrors.first('name') }}</span>
        </div>

        <div class="field">
          <label class="label">Platform</label>
          <div class="control">
            <div v-bind:class="{ 'select': true, 'is-danger': veeErrors.has('platform') }">
              <select
                name="platform"
                v-model="fields.platform"
                v-bind:disabled="update"
                v-validate="'required'"
                data-vv-as="Platform">
                <option value="" disabled>Select one option</option>
                <option value="android">Android</option>
                <option value="ios">iOS</option>
              </select>
            </div>
          </div>
          <span v-show="veeErrors.has('platform')" class="help is-danger">{{ veeErrors.first('platform') }}</span>
        </div>

        <div class="field">
          <label class="label">Package name</label>
          <div class="control">
            <input
              name="package_name"
              type="text"
              placeholder="Package name"
              v-model="fields.package_name"
              v-bind:disabled="update"
              v-bind:class="{ 'input': true, 'is-danger': veeErrors.has('package_name') }"
              v-validate="'required|regex:^[A-Za-z0-9-_.]+$'"
              data-vv-as="Package name">
          </div>
          <span v-show="veeErrors.has('package_name')" class="help is-danger">{{ veeErrors.first('package_name') }}</span>
        </div>

        <div class="field">
          <label class="label">Permissions</label>
          <div class="control">
            <div v-for="permission in this.$store.state.permissions">
              <input
                type="checkbox"
                v-model="checkedPermissions"
                v-bind:value="permission.id"
                v-bind:id="`field_${permission.name}`">
              <label v-bind:for="`field_${permission.name}`">{{ permission.name }}</label>
            </div>
          </div>
        </div>

        <div class="field is-grouped">
          <div class="control">
            <button v-bind:class="{ 'button': true, 'is-primary': true, 'is-loading': isLoading }" v-on:click="submit">Submit</button>
          </div>
          <div class="control">
            <router-link v-bind:to="cancelUrl" class="button" exact>Cancel</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Modal } from 'vue-bulma-modal'

  export default {
    data () {
      return {
        fields: {
          name: '',
          platform: '',
          package_name: ''
        },
        checkedPermissions: [],
        isLoading: false,
        showClientCredentialsModal: false
      }
    },

    computed: {
      cancelUrl () {
        return this.update ? `/clients/${this.$route.params.client_id}` : `/clients`
      }
    },

    methods: {
      submit () {
        this.$validator.validateAll().then((passed) => {
          if (!passed) {
            return
          }

          this.isLoading = true

          this.createOrUpdateClient(this.$route.params.client_id, this.fields)
            .then(() => {
              return this.$store.dispatch('setPermissions', {
                clientId: this.$store.state.client.id,
                params: { permission_id: this.checkedPermissions.join(',') }
              })
            })
            .then(() => {
              if (this.update) {
                this.$router.push(`/clients/${this.$route.params.client_id}`)
              } else {
                this.showClientCredentialsModal = true
              }
            })
            .catch(() => {
              // Add server errors into the existing ErrorBag object
              if (this.$store.state.error.response) {
                Object.keys(this.$store.state.error.response.data.error.validation_errors).forEach(key => {
                  this.veeErrors.add(key, this.$store.state.error.response.data.error.validation_errors[key][0])
                })
              }

              this.isLoading = false
            })
        })
      },

      createOrUpdateClient (clientId, params) {
        // Don't send disabled fields
        // TODO: improve
        if (clientId) {
          delete params.package_name
          delete params.platform
        }

        return clientId
          ? this.$store.dispatch('updateClient', { clientId, params })
          : this.$store.dispatch('createClient', params)
      },

      hideClientCredentialsModal () {
        this.showClientCredentialsModal = false

        this.$nextTick(function () {
          this.$router.push(`/clients/${this.$store.state.client.id}`)
        })
      }
    },

    created () {
      if (this.update) {
        this.$store.dispatch('getClient', {
          clientId: this.$route.params.client_id
        })
          .then(() => {
            return this.$store.dispatch('getClientPermissions', {
              clientId: this.$route.params.client_id
            })
          })
          .then(() => {
            this.fields = {
              name: this.$store.state.client.name,
              platform: this.$store.state.client.platform,
              package_name: this.$store.state.client.package_name
            }

            this.checkedPermissions = this.$store.state.clientPermissions.map(item => item.id)
          })
      }

      this.$store.dispatch('getPermissions', {})
    },

    components: {
      Modal
    },

    props: ['update']
  }
</script>



// WEBPACK FOOTER //
// ClientForm.vue?67666a74